import React from "react";
import AppsMenu from "./AppsMenu";
import UserMenu from "./UserMenu";

export default function NavBarRight(){
    return <div>
        <AppsMenu />
        <UserMenu />
    </div>
}